import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AppConfig } from 'src/app/config-service/app.config';
import { cardDetailResModel } from 'src/app/home/models/cardBalanceResponse.model';
import { HomeActions } from 'src/app/home/ngrx/home-action-types';
import { BalanceService } from 'src/app/home/services/cardBalance.service';
import { FavOpsService } from '../../services/favoriteOperations.service';
import { ProductService } from '../../services/getProducts.service';

const TOKEN_NOT_FOUND = 33;

@Component({
  selector: 'app-query-and-fav',
  templateUrl: './query-and-fav.component.html',
  styleUrls: ['./query-and-fav.component.scss', '../../card-operations.component.css']
})
export class QueryAndFavComponent implements OnInit {
  @Input() modalType!: string;
  @Output() onError = new EventEmitter();

  modalState = 'query'; // query || addfav || result -- 3ds || ccEntry
  addFavCardResult = false;
  addFavName = '';
  aliasNoControlWarningLabel = '';
  queryAlias = '';
  private cardAlias:string = '';
  balanceResult = '0';
  selectedCardProductCode = '0';

  isLoading = false;
  apiSettings = AppConfig.settings;

  constructor(
    private toastr: ToastrService,
    private translate: TranslateService,
    private store: Store,
    public restGetBalance: BalanceService,
    public restAddFavorite: FavOpsService,
    public restGetProducts: ProductService
  ) { }

  ngOnInit(): void {
  }

  onCloseModal(){
    this.onError.emit();
  }

  public getCardBalance(alias: string) {
    if (!this.aliasControl(alias)) {
      this.toastr.error(
        this.translate.instant('CARDOPERATIONS_QUERY_ALIAS_CONTROL_ERROR')
      );
    } else {
      this.isLoading = true;
      new Promise((resolve, reject) => {
        alias = this.aliasReformatter(alias);
        this.restGetBalance.getCardBalanceResult(alias).subscribe(
          (resp:any) => {
            this.isLoading = false;
            if (resp.result.code !== 0) {
              console.log('');
            } else {
              resp.cardlist.forEach((el:any) => {
                this.balanceResult = el.balance;
                this.modalState = 'addfav';
              });
            }
          },
          (error:any) => {
            this.isLoading = false;
            this.toastr.error(
              this.translate.instant('CARDOPERATIONS_QUERY_ALIAS_CONTROL_ERROR')
            );
            reject(error);
          }
        );
      });
    }
  }

  public addtoFavorite = (desc: string) => {
    let alias = this.aliasReformatter(this.queryAlias);
    this.addFavName = desc;
    // const favInfo = favoriteItems.filter(card => card.favorite === aliasNo)[0];

    new Promise((resolve, reject) => {
      this.restAddFavorite
        .addFavoriteResult(alias, this.addFavName, '2')
        .subscribe(
          (resp) => {
            this.modalState = 'result';
            if (resp.result.code == TOKEN_NOT_FOUND) {
              console.log('Giriş Yapınız');
            } else {
              if (resp.favId) {
                const favoriteItem = {
                  type: Number('2'),
                  favorite: alias,
                  description: this.addFavName,
                  typeDescription: "Card",
                  favId: resp.favId
                }
                this.store.dispatch(HomeActions.FavoriteItemAdded({favoriteItem}))
                this.modalState = 'result';
                this.addFavCardResult = true;
              }
            }
          },
          (error:any) => {
            reject(error);
          }
        );
    });
  };

  onChangeQueryAliasNo = (text:any) => {
    this.queryAlias = this.aliasFormatter(this.queryAlias, text);
    this.cardAlias = this.queryAlias.split('-').join('').slice(0, -1);

    this.selectedCardProductCode = '0';

    if (this.modalType === 'AddtoFav') {
      return;
    }

    if (this.aliasControl(this.queryAlias)) {
      this.aliasNoControlWarningLabel = '';
      this.isLoading = true;
      new Promise((resolve, reject) => {
        let alias = this.aliasReformatter(this.queryAlias);

        this.restGetBalance.getCardBalanceResult(alias).subscribe(
          (resp:any) => {
            if (resp.result.code !== 0) {
              this.aliasNoControlWarningLabel = 'Giriş Yapınız!';
              this.onCloseModal();
            } else if (resp.result.code == 0) {
              resp.cardlist.forEach((el:cardDetailResModel) => {
                localStorage.setItem('card-type', el.cardType)
                this.isLoading = false;
                this.balanceResult = el.balance;
                this.selectedCardProductCode = el.product_code;
              });
            } else {
              this.isLoading = false;
              this.aliasNoControlWarningLabel = resp.result.message;
            }
          },
          (error:any) => {
            this.isLoading = false;
            reject(error);
          }
        );
      });
    } else {
      if (this.queryAlias.length > 5) {
        this.aliasNoControlWarningLabel = 'Kart numaranızı eksiksiz giriniz';
      }
    }
  };

  aliasControl(aliasNo:any) {
    let state = false;
    const intArray:Array<any> = [];
    let toplam = 0;
    let lastDigit = 0;
    let modDigit = 0;

    // Sayının Rakamlarını intArray Dizisine Pushlama İşlemi
    const b = aliasNo.split('').map(function (item:any) {
      intArray.push(parseInt(item, 10));
    });

    for (let i = 0; i < 5; i += 1) {
      toplam += intArray[i];
    }

    for (let i = 6; i < 11; i += 1) {
      toplam += intArray[i];
    }

    lastDigit = intArray[12];
    modDigit = toplam % 10;

    /*
      STATE TRUE dönüyorsa girilen alias numarası DOĞRU
      STATE FALSE dönüyorsa girilen alias numarası YANLIŞ
    */
    if (lastDigit === modDigit) {
      state = true;
    }

    return state;
  }

  aliasReformatter(aliasNo:any) {
    /*
      formatter(aliasNo) EXAMPLE:
      Entry = 33800-00002-6
      Output = 3380000002
    */
    const newAlias = aliasNo.split('-').join('');
    return newAlias.substring(0, 10);
  }

  aliasFormatter(oldAliasNo:any, newAliasNo:any) {
    const isDeleted =
      oldAliasNo === newAliasNo + '-' && oldAliasNo.length > newAliasNo.length;
    if (isDeleted) {
      return newAliasNo;
    }
    if (newAliasNo.length === 20) return oldAliasNo;
    else if (newAliasNo.length > 13) {
      var v = newAliasNo.replace(/\s+/g, '').replace(/[^0-9]/gi, '');
      var matches = v.match(/\d{4,16}/g);
      var match = matches && (matches[0] || '');
      var parts = [];

      for (let i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4));
      }

      if (parts.length) {
        return parts.join(' ');
      } else {
        return newAliasNo;
      }
    }
    newAliasNo = newAliasNo.replace(/ /g, '');
    const splitText = newAliasNo.split('-');
    if (splitText.length === 1) {
      // eger "-" ifadesi bulunmuyor ise
      if (newAliasNo.length === 5) {
        // 5. karaktere geldi ise
        return newAliasNo + '-';
      } else if (newAliasNo.length === 6) {
        // 6. karaktere geldi "-" işareti yok ise
        return newAliasNo.slice(0, -1) + '-' + newAliasNo.slice(-1);
      } else {
        // normal durumda ise
        let cache = newAliasNo;
        if (newAliasNo.length > 5) {
          // eğer hızlı yazıldı ve 5. elemandan sonra "-" ifadesi eklenmedi ise
          cache = cache.slice(0, 5) + '-' + cache.slice(5, cache.length);
        }
        if (newAliasNo.length > 12) {
          cache = cache.slice(0, 11) + '-' + cache.slice(11, cache.length);
        }
        if (
          newAliasNo.length < oldAliasNo.length &&
          newAliasNo.replace(/\D/g, '').length === 11
        ) {
          return `${cache.slice(0, cache.length - 1)}-${
            cache[cache.length - 1]
          }`;
        }
        return cache;
      }
    } else if (splitText.length === 2) {
      // eger  bir tane "-" ifadesi bulunuyor ise
      if (splitText[0].length < 6) {
        // eger ilk tireden önceki ifade 6 karakterden küçük ise
        if (newAliasNo.length === 11) {
          // 11. karaktere geldi ise
          return newAliasNo + '-';
        } else if (newAliasNo.length === 12) {
          // 12. karaktere geldi ve hala 1 tane "-" işareti var ise
          return newAliasNo.slice(0, -1) + '-' + newAliasNo.slice(-1);
        } else {
          // normal durumda ise
          let cache = newAliasNo;
          if (newAliasNo.length > 12) {
            cache = cache.slice(0, 11) + '-' + cache.slice(11, cache.length);
          }
          return cache;
        }
      } else {
        // eger ilk tireden önceki ifade 6 karakterden küçük değil ise
        return oldAliasNo;
      }
    } else if (splitText.length === 3) {
      // eger  iki tane "-" ifadesi bulunuyor ise
      if (splitText[0].length < 6 && splitText[1].length < 6) {
        // eger ilk tireden önceki ifade 6 karakterden küçük ise ve 2. tire ile arasında 5 karakter var ise
        if (splitText[2].length < 2) {
          return newAliasNo;
        } else {
          return oldAliasNo;
        }
      } else {
        // Eger tireler arasında fazla karakter yazılmış ise
        return oldAliasNo;
      }
    } else {
      return oldAliasNo;
    }
  }

}